export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5574.60e49c6d.jpg";